import { render, staticRenderFns } from "./ListRegion.vue?vue&type=template&id=0b3c40b6&"
import script from "./ListRegion.vue?vue&type=script&lang=js&"
export * from "./ListRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports